export default "__VITE_ASSET__53d7f2d8__"